export class MailContactsDb{
  public static list = [
    {
      id: 1,
      first_name: 'Alex',
      last_name: 'Dolgove',
      email: 'alex-dolgove@example.com',
      thumb: 'https://via.placeholder.com/150X150',
      thumb_placeholder: 'bg-dark-blue text-white',
      bio: 'tried the suggest...',
      location: 'Palo Alto, CA, United States',
      connections: '20+ Mutual Connections'
    },
    {
      id: 2,
      first_name: 'Steve',
      last_name: 'Smith',
      email: 'steve-smith@example.com',
      thumb: '',
      thumb_placeholder: 'bg-dark-blue text-white',
      bio: 'tried the suggest...',
      location: 'Palo Alto, CA, United States',
      connections: '8+ Mutual Connections'
    },
    {
      id: 3,
      first_name: 'Stella',
      last_name: 'Johnson',
      email: 'stella-johnson@example.com',
      thumb: 'https://via.placeholder.com/150X150',
      thumb_placeholder: 'bg-orange text-white',
      bio: 'tried the suggest...',
      location: 'Palo Alto, CA, United States',
      connections: '13+ Mutual Connections'
    },
    {
      id: 4,
      first_name: 'Domnic',
      last_name: 'Brown',
      email: 'domnic-brown@example.com',
      thumb: '',
      thumb_placeholder: 'bg-orange text-white',
      bio: 'tried the suggest...',
      location: 'Palo Alto, CA, United States',
      connections: '25+ Mutual Connections'
    }
  ];
}
